/**
 * DEV-1263 — Tercihler > Not Ayarları. Ofis (kiracı) başına tek kayıt.
 */
export class NotAyariEntity {
    id!: number;
    takip_acilis_notu_ekle: boolean = false;
}
